export class ReturnDocProcessingModel {
    public result: string;
    public errorMessage: string;
}
